<template>
    <div class="authorization">
        <div class="authorization-tabs authorization_tabset tabset">
            <div  class="authorization_tabset-controls">
                <div class="authorization_tabset-title-1">
                    <input type="radio" name="tabset" id="tab1" aria-controls="login" :checked="openedTab=='login'" v-model="openedTab" value="login">
                    <label class="headline-s" for="tab1">Login</label>
                </div>
                <div v-if="!isApiServer" class="authorization_tabset-title-2">
                    <input type="radio" name="tabset" id="tab2" aria-controls="description" :checked="openedTab=='sign-up'" v-model="openedTab" value="sign-up">
                    <label class="headline-s" for="tab2">Create Account</label>
                </div>
            </div>
            <div class="authorization_tabset-panels">
                <section id="login" class="authorization_tabset-panel">
                    <p class="authorization-login_subtitle" v-if="!isApiServer">Log into your Rothco account for expedited checkout,
                        enhanced product recommendations, and more!
                    </p>
                    <p class="authorization-login_subtitle" v-else>Log into the API Portal for access to documentation and resources.
                    </p>
                    <LoginTab />
                </section> 
                <section id="registration" class="authorization_tabset-panel">
                    <p class="authorization-login_subtitle">Create a Rothco account for expedited checkout, enhanced
                        product recommendations, and more! <br />
                        <span>Note: prospective dealers should <Link :href="route('index.becomeADealer')" class="authorization-learn_more_link">learn more & apply here.</Link></span>
                    </p>
                    <CreateAccountTab v-if="!isApiServer" />
                </section>
                </div>
            </div>
            <div v-if="!isApiServer" class="authorization-banner">
            <img src="@images/men_traveling_auth.png" class="authorization-banner_image" />
            <div class="authorization-banner_description">
                <h2 class="headline-xs authorization-banner_title">Join Our Dealer Network</h2>
                <p class="paragraph-details authorization-banner_subtitle">Join our extensive network of Rothco dealers
                    worldwide</p>
                <div class="authorization-banner_points">
                    <p class="paragraph-details"><span>95%</span> of orders ship within 24hrs</p>
                    <p class="paragraph-details"><span>99%</span> in-stock rate</p>
                    <p class="paragraph-details"><span>4,000+</span> exclusive rothco products</p>
                </div>
                <RothcoCta class="secondary" :href="route('index.becomeADealer')">Learn More & Apply</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import LoginTab from "@/components/auth/LoginTab.vue";
    import CreateAccountTab from "@/components/auth/CreateAccountTab.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { ref, watch, inject } from "vue";
    import { Link, usePage, router } from "@inertiajs/vue3";
    import { storeToRefs } from "pinia";
    import { useSettingsStore } from "@/store/settings";

    let { isApiServer } = storeToRefs(useSettingsStore());
    let route = inject("route");
    const openedTab = ref(usePage().url.includes('login') ? 'login' : 'sign-up');
    watch(openedTab, (newVal)=>{
        router.get(newVal == 'login' ? route('web.login') : route('web.register'), 
            {},
            {
                preserveState: true,
                preserveScroll: true,
                replace: true,
            }
        );
    })

</script>
